import { AvatarModule } from './../avatar/avatar.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { DirectivesModule } from 'src/app/directives/directives.modules';
import { GetPropertyPipe } from 'src/app/pipes/property';
import { MatIconModule } from '@angular/material/icon';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { MatButtonModule } from '@angular/material/button';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatCardModule } from '@angular/material/card';
import { CardActionsComponent } from '../card-actions/card-actions.component';


@NgModule({
  declarations: [ProfileComponent, GetPropertyPipe, ProfileEditComponent ],
  imports: [
    CommonModule,
    AvatarModule,
    DirectivesModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    ImageCropperComponent,
    CardActionsComponent,
    PipesModule
  ],
  exports: [ProfileComponent],
})
export class ProfileModule {}
